import { render } from "./HealthChart.vue?vue&type=template&id=5e5df958&scoped=true"
import script from "./HealthChart.vue?vue&type=script&lang=js"
export * from "./HealthChart.vue?vue&type=script&lang=js"

import "./HealthChart.vue?vue&type=style&index=0&id=5e5df958&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e5df958"]])

export default __exports__